/**
 * streamlines add a dynamic value to opacity.
 * @param {object} param0
 * @param {number|string} param0.$opacity
 * @returns {string}
 */
const dynOpactity = ({ $opacity }) => {
  if ($opacity === undefined) return "";
  return `opacity: ${$opacity};`;
};

export default dynOpactity;
